//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions  } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './MonitoringFormsClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetMonitoringFormsMonitoringFormsQueryParameters = {
  studyId?: number | null;
};

    
export function getMonitoringFormsUrl(studyId?: number | undefined): string {
  let url_ = getBaseUrl() + "/api/MonitoringForms?";
if (studyId === null)
    throw new Error("The parameter 'studyId' cannot be null.");
else if (studyId !== undefined)
    url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getMonitoringFormsDefaultOptions: UseQueryOptions<Types.MonitoringFormDto[], unknown, Types.MonitoringFormDto[]> = {
  queryFn: __getMonitoringForms,
};
export function getGetMonitoringFormsDefaultOptions(): UseQueryOptions<Types.MonitoringFormDto[], unknown, Types.MonitoringFormDto[]> {
  return getMonitoringFormsDefaultOptions;
};
export function setGetMonitoringFormsDefaultOptions(options: UseQueryOptions<Types.MonitoringFormDto[], unknown, Types.MonitoringFormDto[]>) {
  getMonitoringFormsDefaultOptions = options;
}

export function getMonitoringFormsQueryKey(studyId?: number | undefined): QueryKey;
export function getMonitoringFormsQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { studyId,  } = params[0] as GetMonitoringFormsMonitoringFormsQueryParameters;

    return trimArrayEnd([
        'MonitoringFormsClient',
        'getMonitoringForms',
        studyId as any,
      ]);
  } else {
    return trimArrayEnd([
        'MonitoringFormsClient',
        'getMonitoringForms',
        ...params
      ]);
  }
}
function __getMonitoringForms(context: QueryFunctionContext) {
  return Client.getMonitoringForms(
      context.queryKey[2] as number | undefined    );
}

export function useGetMonitoringFormsQuery<TSelectData = Types.MonitoringFormDto[], TError = unknown>(dto: GetMonitoringFormsMonitoringFormsQueryParameters, options?: UseQueryOptions<Types.MonitoringFormDto[], TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useGetMonitoringFormsQuery<TSelectData = Types.MonitoringFormDto[], TError = unknown>(studyId?: number | undefined, options?: UseQueryOptions<Types.MonitoringFormDto[], TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetMonitoringFormsQuery<TSelectData = Types.MonitoringFormDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.MonitoringFormDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let studyId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ studyId,  } = params[0] as GetMonitoringFormsMonitoringFormsQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [studyId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.MonitoringFormDto[], TError, TSelectData>({
    queryFn: __getMonitoringForms,
    queryKey: getMonitoringFormsQueryKey(studyId),
    ...getMonitoringFormsDefaultOptions as unknown as UseQueryOptions<Types.MonitoringFormDto[], TError, TSelectData>,
    ...options,
  });
}

export function setGetMonitoringFormsData(queryClient: QueryClient, updater: (data: Types.MonitoringFormDto[] | undefined) => Types.MonitoringFormDto[], studyId?: number | undefined) {
  queryClient.setQueryData(getMonitoringFormsQueryKey(studyId),
    updater
  );
}

export function setGetMonitoringFormsDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.MonitoringFormDto[] | undefined) => Types.MonitoringFormDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function createMonitoringFormUrl(): string {
  let url_ = getBaseUrl() + "/api/MonitoringForms";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createMonitoringFormMutationKey(): MutationKey {
  return trimArrayEnd([
      'MonitoringFormsClient',
      'createMonitoringForm',
    ]);
}

export function useCreateMonitoringFormMutation<TContext>(options?: Omit<UseMutationOptions<Types.MonitoringFormDto, unknown, Types.CreateMonitoringFormDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.MonitoringFormDto, unknown, Types.CreateMonitoringFormDto, TContext> {
  const key = createMonitoringFormMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((dto: Types.CreateMonitoringFormDto) => Client.createMonitoringForm(dto), {...options, mutationKey: key});
}
  
    
export function updateMonitoringFormUrl(monitoringFormId: string): string {
  let url_ = getBaseUrl() + "/api/MonitoringForms/{monitoringFormId}";
if (monitoringFormId === undefined || monitoringFormId === null)
  throw new Error("The parameter 'monitoringFormId' must be defined.");
url_ = url_.replace("{monitoringFormId}", encodeURIComponent("" + monitoringFormId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function updateMonitoringFormMutationKey(monitoringFormId: string): MutationKey {
  return trimArrayEnd([
      'MonitoringFormsClient',
      'updateMonitoringForm',
      monitoringFormId as any,
    ]);
}

export function useUpdateMonitoringFormMutation<TContext>(monitoringFormId: string, options?: Omit<UseMutationOptions<Types.MonitoringFormDto, unknown, Types.UpdateMonitoringFormDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.MonitoringFormDto, unknown, Types.UpdateMonitoringFormDto, TContext> {
  const key = updateMonitoringFormMutationKey(monitoringFormId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((dto: Types.UpdateMonitoringFormDto) => Client.updateMonitoringForm(monitoringFormId, dto), {...options, mutationKey: key});
}